module.exports = __webpack_public_path__ + "assets/img/sydx.12f33c04.png";